export const AUTH_CRED = 'AUTH_CRED';
export const AUTH_TOKEN_KEY = process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY ?? 'authToken';

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: 'auth/register',
    LOGIN: 'auth/login',
    REFRESH: 'auth/refresh',
    LOGOUT: 'auth/logout',
    LOGOUT_SESSION: 'auth/logout-session',
    ME: '/auth/me',
  },
  MANUFACTURERS: 'manufacturers',
  MEDICINES: 'medicines',
  CATEGORIES: 'categories',
  PACKAGE_DETAILS: 'package-details',
  ACTIVE_INGREDIENTS: 'active-ingredients',
  SIDE_EFFECTS: 'side-effects',
  SUPPLIERS: 'suppliers',
  PURCHASE: 'purchase-invoices',
  SALES_INVOICE: 'sales-invoice',
};
